import React from 'react';
import './styles/Filters.css';

const DurationSelector = ({ selectedDuration, onDurationSelect, durations = [5, 10, 15, 20] }) => {
  return (
    <div className="duration-section">
      <div className="duration-label">Walking Duration</div>
      <div className="duration-buttons">
        {durations.map(duration => (
          <button 
            key={duration} 
            className={`duration-btn${selectedDuration === duration ? " active" : ""}`}
            onClick={() => onDurationSelect(duration)}
          >
            {duration} min
          </button>
        ))}
      </div>
    </div>
  );
};

export default DurationSelector; 